import { actions } from "./actions";

export const pageIndices = [0, 1, 2, 3, 4, 5, 6, 7] as const;
export type PageIndex = typeof pageIndices[number];

export interface CreateUpdateFinancialPlanFlowData {
  todo: string;
}

export type ProgressPointState = "Complete" | "InProgress" | "NotStarted";

export interface ProgressPoint {
  name: string;
  state: ProgressPointState;
}

export interface FlowState<T> {
  pageIndex: PageIndex;
  progressState: ProgressPoint[];
  data: T;
}

export type ActionPayload =
  | {
      type: actions.RESET_TO_DEFAULT_DATA;
      payload: undefined;
    }
  | {
      type: actions.SET_PAGE_INDEX;
      payload: number;
    }
  | {
      type: actions.INCREMENT_PAGE_INDEX;
      payload: undefined;
    }
  | {
      type: actions.DECREMENT_PAGE_INDEX;
      payload: undefined;
    };
